import { api, type ApiResponse } from '@/lib/api';
import type {
  MarketingDashboardQuery,
  MarketingDashboardResponse,
} from '@troia-v3/types';

/**
 * API client for the Marketing Dashboard module.
 *
 * Backend endpoint: GET /api/dashboards/marketing
 */
export const dashboardsMarketingApi = {
  async get(query: MarketingDashboardQuery): Promise<MarketingDashboardResponse> {
    const response = await api.get<ApiResponse<MarketingDashboardResponse>>(
      'dashboards/marketing',
      { params: query },
    );
    return response.data.data!;
  },
};
